import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import aboutImage from "../assets/images/gallery-2.jpg";

function About() {
    return (
        <main className="about-page">

            <Helmet>
                <title>Despre noi | Cris Gym Fitness</title>
                <meta
                    name="description"
                    content="Afla mai multe despre Cris Gym Fitness, o sala moderna, curata si orientata spre performanta, disciplina si progres real."
                />
            </Helmet>

            {/* HERO */}
            <section className="about-hero">
                <div className="about-hero-container">
                    <h1>Despre Cris Gym Fitness</h1>
                    <p>
                        Un spatiu dedicat performantei, disciplinei si progresului real.
                    </p>
                </div>
            </section>

            {/* STORY */}
            <section className="about-story">
                <div className="about-container">
                    <h2>Un loc unde vii sa muncesti, nu doar sa te antrenezi</h2>
                    <p>
                        Cris Gym Fitness este construit pentru oamenii care vor rezultate reale.
                        Fie ca esti la inceput sau ai deja experienta, aici gasesti un mediu
                        organizat, echipamente moderne si o atmosfera care te motiveaza sa revii.
                    </p>

                    <p>
                        Punem accent pe disciplina, consistenta si progres. Nu este doar o sala,
                        este un loc in care iti construiesti obiceiuri si rezultate pe termen lung.
                    </p>
                </div>
            </section>

            {/* VALUES */}
            <section className="about-values">
                <div className="about-container values-grid">

                    <div className="value-card">
                        <h3>Curatenie impecabila</h3>
                        <p>
                            Un spatiu curat, aerisit si bine intretinut, unde te poti antrena
                            confortabil si in siguranta.
                        </p>
                    </div>

                    <div className="value-card">
                        <h3>Disciplina</h3>
                        <p>
                            Mediul potrivit pentru a-ti construi rutina si a ramane constant.
                        </p>
                    </div>

                    <div className="value-card">
                        <h3>Echipamente moderne</h3>
                        <p>
                            Aparatura pregatita pentru antrenamente eficiente si variate.
                        </p>
                    </div>

                    <div className="value-card">
                        <h3>Atmosfera motivanta</h3>
                        <p>
                            O energie care te impinge sa lucrezi mai bine, de fiecare data.
                        </p>
                    </div>

                </div>
            </section>

            {/* IMAGE + TEXT */}
            <section className="about-split">
                <div className="about-container split-grid">

                    <div className="split-image">
                        <img src={aboutImage} alt="Cris Gym Fitness" />
                    </div>

                    <div className="split-content">
                        <h2>Mai mult decat o sala</h2>
                        <p>
                            La Cris Gym Fitness nu vii doar sa faci un antrenament. Vii sa
                            lucrezi intr-un mediu organizat, curat si concentrat pe progres.
                        </p>

                        <p>
                            Fiecare detaliu conteaza: de la echipamente, la atmosfera si
                            pana la modul in care este intretinut spatiul.
                        </p>

                        <Link to="/abonamente" className="about-btn">
                            Vezi abonamentele
                        </Link>
                    </div>

                </div>
            </section>

            {/* CTA */}
            <section className="about-cta">
                <div className="about-container">
                    <h2>Incepe acum</h2>
                    <p>
                        Fa primul pas catre o versiune mai buna a ta.
                    </p>

                    <div className="about-cta-buttons">
                        <Link to="/contact" className="cta-btn primary">
                            Contacteaza-ne
                        </Link>

                        <Link to="/abonamente" className="cta-btn secondary">
                            Vezi abonamentele
                        </Link>
                    </div>
                </div>
            </section>

        </main>
    );
}

export default About;